
import React from 'react';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Elite() {
  return (
    <div className='pad'>
      <div className='group message2 centered-text boost-container'>
        <span className='large-text5'>
          <TranslateText text="Elite Credit Repair Service" />
        </span>
        <span className='large-text5'>
          <TranslateText text="45-90 Days Guaranteed" />
        </span>
        <span className='large-text5'>$750</span>
      </div>
      <div className="separator2"></div>
    </div>
  );
}

export default Elite;

// import React from 'react'

// function Elite() {
//   return (
//     <div className='pad'>
//         <div className='group message2 centered-text boost-container'>
//         <span className='large-text5'>Elite Credit Repair Service</span>
//         <span className='large-text5'>45-90 Days Guaranteed</span>
//         <span className='large-text5'>$750</span> </div>
//         <div className="separator2"></div>
//     </div>
//   )
// }

// export default Elite
